export default class EventBusRouter {
    constructor(dispatch) {
        this._nextHandler = () => null;
        this._dispatch = dispatch;
        this.exec = this.exec.bind(this);
    }
    exec(name, ev) {
        this._dispatch(name, ev);
        if (this._nextHandler) {
            this._nextHandler(name, ev);
        }
    }
    setNext(next) {
        this._nextHandler = next;
    }
}
//# sourceMappingURL=EventBusRouter.js.map